import moment from 'moment-timezone';
import _ from 'lodash';

import * as Actions from './actions';

/**
 * @TODO: maybe add some in-memory caching for pages?
 */

const initialState = {
  payload: {},
  data: {},
  meta: {},
  filters: {
    selectionRange: {
      startDate: moment().startOf('year'), // @XXX
      endDate: moment().endOf('year'),
      key: 'selection',
    },
    criteria: [
      { type: 'asset', value: 'Firewall A' }, // @TODO
      { type: 'src', value: '192.168.1.1' },
    ],
  },
  loading: false,
  error: null,
};


const PageReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case Actions.Page.PAGE: {
      const { payload } = action;
      if (!_.isEqual(payload, state.payload)) {
        return {
          ...initialState,
          payload,
        };
      }
      return {
        ...state,
        payload,
      };
    }
    case Actions.Page.PAGE_FETCH:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case Actions.Page.PAGE_DATA_PART: {
      const data = {
        ...state.data,
        [action.part]: action.data,
      };
      const meta = {
        ...state.meta,
      };
      if (action.meta) {
        _.extend(meta, action.meta);
      }

      return {
        ...state,
        data,
        meta,
      };
    }
    case Actions.Page.PAGE_META: {
      const { meta = {} } = action;

      return {
        ...state,
        meta,
      };
    }
    case Actions.Page.PAGE_FILTER: {
      const { filterKey, filterObj } = action;
      const filters = {
        ...state.filters,
        [filterKey]: filterObj,
      };
      return {
        ...state,
        filters,
      };
    }
    case Actions.Page.PAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case Actions.Page.PAGE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default PageReducer;



// WEBPACK FOOTER //
// ./src/redux/PageReducer.js